import React, { useEffect } from 'react';
import { LowerWrapper, FilterEventsItemWrapper, FilterEventsItem } from './FilterEventsPanel.styles';
import { useRef } from 'react';
import { useEventTypeStore } from '../../../context/EventTypeContext';
import { EventTypeFilter } from '../../../types/ViewModel/EventTypeFilter';

type Props = {
    onSelected: (filterEventsItem: EventTypeFilter) => void;
    onCancel: () => void;
    isOpen: boolean;
};

const FilterEventsPanelComponent: React.FC<Props> = (props) => {
    const { eventTypeDataPort } = useEventTypeStore();

    const ref = useRef<HTMLInputElement>(null);
    useEffect(() => {
        const checkIfClickedOutside = (event) => {
            if (props.isOpen && ref.current && !ref.current.contains(event.target)) {
                props.onCancel();
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [props.isOpen]);

    const filterEventsItemClicked = (filterEventsItem: EventTypeFilter) => {
        props.onSelected(filterEventsItem);
    };

    const hasEvTypeGroupData = (): boolean => {
        if (eventTypeDataPort && eventTypeDataPort.eventTypeFilterList && eventTypeDataPort.eventTypeFilterList.length > 0) return true;
        return false;
    };

    const filterItemKey = (item: EventTypeFilter): number => {
        return item.eventTypeFilterId;
    };

    return (
        <>
            {props.isOpen && hasEvTypeGroupData() && (
                <LowerWrapper ref={ref}>
                    <FilterEventsItemWrapper>
                        {eventTypeDataPort?.eventTypeFilterList.map((item) => {
                            return (
                                <FilterEventsItem key={filterItemKey(item)} onClick={() => filterEventsItemClicked(item)}>
                                    {item.filterHeading}
                                </FilterEventsItem>
                            );
                        })}
                    </FilterEventsItemWrapper>
                </LowerWrapper>
            )}
        </>
    );
};

export default FilterEventsPanelComponent;
